/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import ParticipantEmailModalContainer from './participant.email.modal.container';

const ParticipantEmailModal = () => (
  <div id="participant-email-modal-container">
    <ParticipantEmailModalContainer />
  </div>
);

export default ParticipantEmailModal;
